import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Container, Row, Col } from "react-bootstrap";
import { SideBarMenu } from "../../../../stories/SideBarMenu/SideBarMenu";
import { CoachAccountInfoSidebar } from "../../../../stories/CoachAccountInfoSidebar/CoachAccountInfoSidebar";
import { Button } from "../../../../stories/Button/Button";
import {
  ChatFilled,
  ChatOutlined,
  HomeFilled,
  Homeoutlined,
  InsightsFilled,
  InsightsOutlined,
  NotificationFilled,
  Notificationoutlined,
  ReviewFilled,
  ReviewOutlined,
  ScheduleFilled,
  ScheduleOutlined,
  ShortLogo,
} from "../../../../constant/imagePath";
import Fonts from "../../../../stories/assets/Fonts";
import Colors from "../../../../stories/assets/Colors";
import { useHistory, useLocation } from "react-router-dom";

import classes from "./PageLayout.module.css";
import { isMobileViewHook } from "../../../../CustomHooks/isMobileViewHook";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../../store/Actions/commonAction";

const PageLayout = ({ children, renderData }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.commonReducer.activeTab);
  console.log({ activeTab });
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => [isMobileViewHook(setIsMobile, 992)], []);

  const location = useLocation();

  const sidebarMenus = [
    {
      icon: Homeoutlined,
      hoverIcon: HomeFilled,
      text: "Todo",
      activeText: "todo",
      onClick: () => history.push("/todo"),
    },
    {
      icon: Notificationoutlined,
      hoverIcon: NotificationFilled,
      text: "Notifications",
      activeText: "notifications",
      onClick: () => history.push("/notifications"),
    },
    {
      icon: ScheduleOutlined,
      hoverIcon: ScheduleFilled,
      text: "Schedule",

      activeText: "schedule",
      onClick: () => history.push("/schedule"),
    },
    {
      icon: ChatOutlined,
      hoverIcon: ChatFilled,
      text: "Chat",

      activeText: "chat",
      onClick: () => history.push("/chat"),
    },
    {
      icon: ReviewOutlined,
      hoverIcon: ReviewFilled,
      text: "Reviews",

      activeText: "reviews",
      onClick: () => history.push("/reviews"),
    },
    {
      icon: InsightsOutlined,
      hoverIcon: InsightsFilled,
      text: "Insights",
      activeText: "insights",

      onClick: () => history.push("/insights"),
    },
  ];
  let currentRoute = useLocation()?.pathname?.split("/")[1];

  // useEffect(() => {
  //   currentRoute = location?.pathname?.split("/")[1];
  // }, []);

  console.log({ currentRoute });

  function navigateOnTab(route, tab) {
    if (route === currentRoute) {
      dispatch(setActiveTab(tab));
    } else {
      dispatch(setActiveTab(tab));
      history.push("/" + route);
    }
  }

  const sidebarlinks = [
    {
      heading: "Edit Profile",
      list: [
        {
          title: "Personal info",
          activeText: "personal-info",
          onClick: () => navigateOnTab("edit-profile", "personal-info"),
        },
        {
          title: "Photo & Video",
          activeText: "photo-and-video",
          onClick: () => navigateOnTab("edit-profile", "photo-and-video"),
        },
        {
          title: "FAQ",
          activeText: "faq",
          onClick: () => navigateOnTab("edit-profile", "faq"),
        },
      ],
    },
    {
      heading: "Edit Lesson Info",
      list: [
        {
          title: "Basic Info",
          activeText: "basic-info",
          onClick: () => navigateOnTab("edit-lesson-info", "basic-info"),
        },
        {
          title: "What’s included",
          activeText: "whats-included",
          onClick: () => navigateOnTab("edit-lesson-info", "whats-included"),
        },
        {
          title: "Location",
          activeText: "location",
          onClick: () => navigateOnTab("edit-lesson-info", "location"),
        },
      ],
    },
    {
      heading: "Profile Settings",
      list: [
        {
          title: "Privacy settings",
          activeText: "privacy-settings",
          onClick: () => navigateOnTab("profile-settings", "privacy-settings"),
        },
        {
          title: "Payout methods",
          activeText: "payout-methods",
          onClick: () => navigateOnTab("profile-settings", "payout-methods"),
        },
        {
          title: "Notifications",
          activeText: "notifications",
          onClick: () => navigateOnTab("profile-settings", "notifications"),
        },
      ],
    },
  ];

  return (
    <>
      <div className={[classes.PageLayoutScreen].join(" ")}>
        <Container fluid className={`p-0 ${classes.container}`}>
          <Row className={`g-0 ${classes.row}`}>
            <Col md={12}>
              <div className={[classes.contentDiv].join(" ")}>
                {!isMobile && (
                  <SideBarMenu
                    logo={ShortLogo}
                    items={sidebarMenus}
                    state={location?.pathname?.split("/")[1]}
                    customStyle={{ minHeight: "100vh", height: "100%" }}
                  />
                )}
                {!isMobile && (
                  <CoachAccountInfoSidebar
                    links={sidebarlinks}
                    active={activeTab}
                    sidebarClassName={classes.sidebar}
                  />
                )}
                <div className={classes.content}>{children}</div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

// export default function DashboardScreen() {
//   const [isMobile, setIsMobile] = useState(false);
//   useEffect(() => {
//     isMobileViewHook(setIsMobile);
//   }, []);
//   return isMobile ? <DashboardMobileScreen /> : <DashboardScreenDesktop />;
// }

export default PageLayout;
